import { useState, useEffect } from "react";
import { Send, X, Clock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { trackCTA } from "@/lib/analytics";

export function FloatingCTA({ scrollToSection }) {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 600);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  if (!visible || dismissed) return null;

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end gap-2" data-testid="floating-cta">
      <button
        onClick={() => setDismissed(true)}
        className="self-end w-6 h-6 rounded-full bg-gray-800/80 text-gray-500 hover:text-white flex items-center justify-center text-xs transition-colors"
        aria-label="Cerrar"
      >
        <X className="w-3.5 h-3.5" />
      </button>
      <div className="bg-[#1A1F2E]/95 backdrop-blur-xl border border-gray-700/60 rounded-2xl p-4 shadow-2xl shadow-black/40 max-w-[280px]">
        <div className="flex items-center gap-2 mb-2">
          <Clock className="w-4 h-4 text-green-400" />
          <span className="text-green-400 text-xs font-semibold">Respuesta en 24h</span>
        </div>
        <p className="text-gray-300 text-sm mb-3 leading-relaxed">
          ¿Necesitas una auditoría de IA para tu clínica?
        </p>
        <div className="flex flex-col gap-2">
          <Button
            onClick={() => { trackCTA("floating_diagnostico"); scrollToSection("diagnostico"); }}
            className="btn-primary w-full text-sm py-2"
            data-testid="floating-cta-form"
          >
            <Send className="w-3.5 h-3.5" />
            Solicitar diagnóstico
          </Button>
          <a
            href="mailto:info@tecnoabogado.com?subject=Consulta%20auditoría%20IA%20clínica"
            onClick={() => trackCTA("floating_email")}
            className="flex items-center justify-center gap-2 text-gray-400 hover:text-blue-400 text-xs py-1.5 transition-colors"
            data-testid="floating-cta-email"
          >
            info@tecnoabogado.com
          </a>
        </div>
      </div>
    </div>
  );
}
